import clsx from 'clsx'

import {
    useMemo,
} from 'react'
import {
    strToDate,
} from 'app/utils/date'

import useRangeSelectorStyles from 'app/tss/rangeSelector.styles'
import useStyles from './DateRangeSelector.style'
import rangeToDayPassed from './rangeToDayPassed'
import DateSelect from './DateSelect'
import {
    DateRangeSelectorCustomClasses,
} from './DateRangeSelector.types'

const EMPTY_OBJECT = {}

type Props = {
    mini: boolean,
    options: {
        label: string,
        value: number,
    }[]
    selectOption: (val, e) => void,
    showTimeRange: boolean,
    onChangeRange: (newVal: Date, e) => void,
    from?: string,
    to?: string,
    classes?: DateRangeSelectorCustomClasses
}

const DateRangeSelector = ({
    mini,
    options,
    selectOption,
    showTimeRange,
    onChangeRange,
    from = null,
    to = null,
    classes: customClasses = EMPTY_OBJECT,
}: Readonly<Props>) => {
    const {
        classes,
        cx,
    } = useStyles()
    const {
        classes: rangeSelectorClasses,
    } = useRangeSelectorStyles()

    const dayPassed = from && to ? rangeToDayPassed({
        from: strToDate(from),
        to: strToDate(to),
    }) : undefined

    const dateSelectorClasses = useMemo(() => {
        return {
            container: cx(
                classes.datePicker,
                customClasses.dateSelector?.container,
            ),
            ...(customClasses.dateSelector || {}),
        }
    }, [
        classes.datePicker,
        customClasses.dateSelector,
        cx,
    ])

    return (
        <div className={rangeSelectorClasses.wrapper}>
            {!mini && (
                <div className={classes.optionsWrapper}>
                    {options.map(({
                        label,
                        value,
                    }) => {
                        return (
                            <div
                                data-testid={`date-range-button-${value}`}
                                key={value}
                                className={clsx(classes.option, {
                                    [classes.selectedOption]: dayPassed === value,
                                })}
                                onMouseDown={(e) => {
                                    selectOption(value, e)
                                }}
                            >
                                {label}
                            </div>
                        )
                    })}
                </div>
            )}
            {showTimeRange && (
                <div className={cx(
                    rangeSelectorClasses.inputsWrapper,
                    customClasses.inputsWrapper,
                )}
                >
                    <div className={cx(rangeSelectorClasses.input, customClasses.inputWrapper)}>
                        <DateSelect
                            title="From"
                            onChange={onChangeRange}
                            name="from"
                            value={from}
                            classes={dateSelectorClasses}
                        />
                    </div>
                    <div className={cx(rangeSelectorClasses.input, customClasses.inputWrapper)}>
                        <DateSelect
                            title="To"
                            onChange={onChangeRange}
                            name="to"
                            value={to}
                            classes={dateSelectorClasses}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default DateRangeSelector
